import { CardTypeEnum, CircularProgress, Difficulty, secondaryColors, StyledCheckIcon } from '@tryhackme/thm-ui-components';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { RoomDifficulty } from 'src/common/enums/rooms';
import { Room } from 'src/features/dashboard/components/my-learning/my-learning.types';
import { StyledRoomCard, StyledRoomImage, StyledRoomTag } from './room-card.styles';
export const RoomCard = ({
  room,
  progress
}: {
  room: (Room & {
    difficulty: RoomDifficulty;
  }) | undefined;
  progress: number;
}) => {
  if (!room) return null;
  return <StyledRoomCard href={`/r/room/${room.code}`} target="_blank" data-sentry-element="StyledRoomCard" data-sentry-component="RoomCard" data-sentry-source-file="room-card.tsx">
      <div>
        <StyledRoomImage width="2rem" height="2rem" src={room.imageURL} alt={room.title} data-sentry-element="StyledRoomImage" data-sentry-source-file="room-card.tsx" />
        <p>{room.title}</p>
      </div>
      <div>
        <Difficulty isDarkVersion hasIcon difficulty={room.difficulty} data-sentry-element="Difficulty" data-sentry-source-file="room-card.tsx" />
        <StyledRoomTag data-sentry-element="StyledRoomTag" data-sentry-source-file="room-card.tsx">Room</StyledRoomTag>
        <div>
          {progress === 100 && <StyledCheckIcon $cardType={CardTypeEnum.ROOM} icon={faCheckCircle} data-testid="completed-icon" />}
          {progress > 0 && progress < 100 && <CircularProgress textColor={secondaryColors.grey[400]} progressValue={progress} size={30} />}
        </div>
      </div>
    </StyledRoomCard>;
};